export default __webpack_public_path__ + "sounds/correct3.mp3";